/**
 * CSV download helper. Builds a fully-quoted CSV blob (Excel-friendly:
 * UTF-8 BOM + CRLF line endings + double-quote escape) and triggers a
 * browser download. No external library needed.
 */

function escapeCell(v) {
  if (v === null || v === undefined) return "";
  const s = typeof v === "string" ? v : String(v);
  // Always quote — keeps Excel happy with commas, newlines, and unicode.
  return `"${s.replace(/"/g, '""')}"`;
}

export function rowsToCsv(headers, rows) {
  const headerLine = headers.map(escapeCell).join(",");
  const body = rows
    .map((row) => row.map(escapeCell).join(","))
    .join("\r\n");
  return body ? `${headerLine}\r\n${body}\r\n` : `${headerLine}\r\n`;
}

export function downloadCsv(filename, headers, rows) {
  const csv = rowsToCsv(headers, rows);
  const bom = "\ufeff"; // UTF-8 BOM so Excel detects encoding correctly.
  const blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Defer revoke to next tick so older browsers don't choke.
  setTimeout(() => URL.revokeObjectURL(url), 100);
}

/** Standard filename: "zion-reports-{tab}-{from}_{to}.csv" */
export function reportFilename(tabKey, params) {
  const from = params?.date_from || "all";
  const to = params?.date_to || "all";
  return `zion-reports-${tabKey}-${from}_${to}.csv`;
}
